const setActiveShell = (shell) => {
    return {
        type: 'SET_BOTH_SHELL',
        payload: shell
    };
};

const setLeftShell = (shell) => {
    return {
        type: 'SET_LEFT_SHELL',
        payload: shell
    };
};

const setRightShell = (shell) => {
    return {
        type: 'SET_RIGHT_SHELL',
        payload: shell
    };
};

// eslint-disable-next-line
export default {
    setActiveShell,
    setLeftShell,
    setRightShell
};

// GIve away campaign
// Gleam ?
